<template>
  <multiselect  
    @input="handleSelect"
    v-model="chosenOption"
    :options="data"
    track-by="id"
    :label="locale === 'ka' ? 'value' : 'valueeng'"
    :show-labels="false"
    class="select-field"
    :placeholder="$t('applications.choose')+' '+placeholder"
    :multiple="isMultiple"
  >
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';

export default {
  name: 'input-select',
  props: ['placeholder', 'data', 'contentid'],
  components: { Multiselect },

  computed: {
    ...mapGetters({
      locale: 'language/locale'
    }),
    // 1. Compute whether multiple mode should be active
    isMultiple() {
      return Number(this.contentid) === 57;
    }
  },

  watch: {
    // 2. Reset to the correct type whenever data or mode changes
    data() {
      this.resetChosenOption();
    },
    contentid() {
      this.resetChosenOption();
    }
  },

  data() {
    return {
      // 3. Initialize as a string/null, but we will fix it on mount if needed
      chosenOption: ''
    }
  },

  created() {
    // Ensure correct initial data type based on the contentid
    this.resetChosenOption();
  },

  methods: {
    handleSelect() {
      this.$emit('input', this.chosenOption);
    },
    // 4. Helper to reset selections properly based on mode
    resetChosenOption() {
      this.chosenOption = this.isMultiple ? [] : '';
      this.$emit('input', this.chosenOption); // Notify parent of the reset
    }
  }
};
</script>

<style scoped>
  .select-field {
    display: inline-block;
    width: 500px;
  }
</style>